import { SelectOption } from "@idw-types/common";

export const BOOLEAN_RADIO_INPUT_OPTIONS: Array<SelectOption> = [
    { label: "Yes", value: "true" },
    { label: "No", value: "false" }
];